import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, Data, Router} from '@angular/router';
import {EVENT_DETAILS} from 'src/app/app-routing.module';
import {AbstractComponent} from "@components";
import {EventItem, EventItemType, EventRaceItem, Lookups, Sport} from "@model";
import {EventService} from "@services";
import {EventDetailsHolder} from "@resolvers";

@Component({
  selector: 'app-event-preview',
  templateUrl: './event-preview.component.html',
  styleUrls: ['./event-preview.component.scss']
})
export class EventPreviewComponent extends AbstractComponent implements OnInit {
  @Input() eventDetailsHolder?: EventDetailsHolder;
  @Input({required: true}) languages: Lookups[] = [];
  @Input() countries: Lookups[] = [];
  @Input() sports: Sport[] = [];
  @Input() isPreviewComponent: boolean = true;

  event?: EventItem;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
  ) {
    super();
  }

  ngOnInit() {
    if (this.eventDetailsHolder) {
      this.event = this.eventDetailsHolder.eventItem;
    }
  }

  goToEventDetailsPage() {
    this.router.navigate([EVENT_DETAILS], {
      relativeTo: this.route,
      queryParams: {eventId: this.event?.id},
    });
  }

  protected readonly EventItemType = EventItemType;
}
